export default __webpack_public_path__ + "static/media/wind-archer.3cf0578d.png";